import React, { Component } from "react";
import Chart, { seriesName, selectColor, approximationSum } from "./Chart.js";

export default class RainfallTotalsChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      failed: false,
      noData: false,

      dailyData: null,

      options: {
        title: {
          text: "Weekly Rainfall Totals"
        },
        yAxis: [
          {
            title: {
              text: "Rainfall (mm)"
            },
            lineWidth: 1,
            gridLineWidth: 0,
            tickInterval: 1,
            tickWidth: 1,
            tickLength: 5,
            endOnTick: false,
            startOnTick: false,
            min: 0,
            opposite: false
          }
        ]
      }
    };
  }

  componentDidMount() {
    this.loadChart();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.startDate !== this.props.startDate ||
      prevProps.stopDate !== this.props.stopDate ||
      prevProps.stationId !== this.props.stationId ||
      prevProps.seasonStart !== this.props.seasonStart ||
      prevProps.seasonStop !== this.props.seasonStop ||
      prevProps.dailyData !== this.props.dailyData
    ) {
      this.loadChart();
    }
  }

  loadChart() {
    if (this.props.loadingData) {
      this.setState({ loading: true, noData: false, failed: false });
      return;
    }

    if (!this.props.dailyData) {
      this.setState({ loading: false, failed: true });
      return;
    }

    this.setState({ loading: true, noData: false, failed: false }, () => {
      const dailyData = {};

      Object.keys(this.props.dailyData).forEach(year => {
        const yearData = this.props.dailyData[year];
        if (yearData && yearData.RNDATA) {
          const rnValues = yearData.RNDATA;
          const formattedData = [];

          rnValues.forEach(value => {
            const numValue = parseFloat(value);

            if (!isNaN(numValue)) {
              formattedData.push({
                amount: numValue,
                status: 'valid'
              });
            } else {
              formattedData.push({
                amount: null,
                status: 'missing'
              });
            }
          });

          dailyData[year] = {
            data: {
              RN: {
                T: formattedData
              }
            }
          };
        }
      });

      if (Object.keys(dailyData).length > 0) {
        this.setState({ dailyData: dailyData }, () => {
          this.initializeChart();
        });
      } else {
        this.setState({ loading: false, failed: true });
      }
    });
  }

  initializeChart() {
    if (!this.state.dailyData) return false;
    let noData = true;

    this.setState({
      options: {
        ...this.state.options,
        series: [
          ...Object.keys(this.state.dailyData).map(year => {
            const rnData = this.state.dailyData[year]
              ? this.state.dailyData[year].data.RN.T.map(data => {
                  if (data.status !== "missing") noData = false;
                  return data.amount;
                })
              : [];

            return {
              name: seriesName(year),
              type: "column",
              data: rnData,
              dataGrouping: {
                approximation: approximationSum
              },
              color: selectColor(
                year,
                this.props.seasonStart,
                this.props.graphOptions
              ),
              pointPadding: 0,
              pointStart: new Date(this.props.seasonStart).getTime(),
              enableMouseTracking: true
            };
          })
        ]
      },
      loading: false,
      noData: noData,
      failed: false
    });
  }

  render() {
    return (
      <Chart
        options={this.state.options}
        loading={this.state.loading}
        failed={this.state.failed}
        noData={this.state.noData}
      />
    );
  }
}